import { callApi } from '@local_modules/generic/fetch.js'

export async function loadDataStatements (context) {
  console.log('loadDataStatements', context)
  const orgId = context.showOrgId
  if (!orgId) return

  const url = '/api/pg-financials/data/:orgId/pg-statement-values/:monthFrom/:monthTo/:currencyCode'

  const loadedData = await callApi(url,
    {
      orgId,
      monthFrom: context.dates?.min,
      monthTo: context.dates?.max,
      currencyCode: context.currencySymbol
    }
  )

  console.log('loadDataStatements loadedData', loadedData)

  return loadedData
}
